module.exports = __webpack_public_path__ + "img/career-b4.206203f2.webp";